import { NavigationItem, NavbarMenuItemProps } from "./types";
import { Camera } from "lucide-react";

export type { NavbarMenuItemProps };

export const getNavigationData = () => {
  const services: NavbarMenuItemProps[] = [
    {
      name: "Tous nos services",
      path: "/services"
    },
    {
      name: "Professionnels", 
      path: "/services/professionnels"
    },
    {
      name: "Collectivités",
      path: "/services/collectivites"
    },
    {
      name: "Particuliers",
      path: "/services/particuliers"
    },
    {
      name: "Véhicules",
      path: "/services/vehicules"
    }
  ];

  const serviceOfferings: NavbarMenuItemProps[] = [
    {
      name: "Location de bennes",
      path: "/nos-services/location-bennes"
    },
    {
      name: "Achat de métaux",
      path: "/nos-services/achat-metaux"
    },
    {
      name: "Démolition",
      path: "/nos-services/demolition"
    },
    {
      name: "Prestation RSE",
      path: "/nos-services/prestation-rse"
    },
    {
      name: "Solutions par métier",
      path: "/nos-metiers"
    },
    {
      name: "DIB",
      path: "/valorisation/dib"
    },
    {
      name: "Huiles minérales",
      path: "/services/huiles-minerales"
    },
    {
      name: "Huiles alimentaires",
      path: "/services/huiles-alimentaires"
    }
  ];

  const valorisations: NavbarMenuItemProps[] = [
    {
      name: "Guide valorisation",
      path: "/guide-valorisation"
    },
    {
      name: "Valorisation",
      path: "/valorisation"
    },
    {
      name: "Métaux ferreux",
      path: "/valorisation/metaux-ferreux"
    },
    {
      name: "Métaux non ferreux",
      path: "/valorisation/metaux-non-ferreux"
    },
    {
      name: "DEEE",
      path: "/valorisation/deee"
    },
    {
      name: "Papiers/Cartons",
      path: "/valorisation/papiers-cartons"
    }
  ];

  const groupItems: NavbarMenuItemProps[] = [
    {
      name: "Occitanie",
      path: "/occitanie"
    },
    {
      name: "Histoire",
      path: "/histoire"
    },
    {
      name: "Engagements",
      path: "/engagements"
    },
    {
      name: "Nos Sites",
      path: "/sites"
    },
    {
      name: "Recrutement",
      path: "/recrutement"
    }
  ];

  const sitesItems: NavbarMenuItemProps[] = [
    {
      name: "Photos des sites",
      path: "/valoguide",
      icon: Camera
    }
  ];

  const valocapItems: NavbarMenuItemProps[] = [
    {
      name: "Valocap",
      path: "/valocap"
    },
    {
      name: "ValoGuide",
      path: "/valoguide"
    }
  ];

  // Legacy items for backward compatibility
  const servicesItems: NavigationItem[] = [
    {
      label: "Location de bennes",
      href: "/nos-services/location-bennes",
      description: "Location de bennes pour tous vos projets"
    },
    {
      label: "Achat de métaux",
      href: "/nos-services/achat-metaux",
      description: "Rachat de métaux au meilleur prix"
    },
    {
      label: "Démolition",
      href: "/nos-services/demolition",
      description: "Services de démolition professionnels"
    },
    {
      label: "Prestation RSE",
      href: "/nos-services/prestation-rse",
      description: "Solutions environnementales responsables"
    },
    {
      label: "Solutions par métier",
      href: "/nos-metiers",
      description: "Solutions adaptées à votre activité professionnelle"
    },
    {
      label: "DIB",
      href: "/valorisation/dib",
      description: "Gestion des déchets industriels banals"
    }
  ];

  const groupeItems: NavigationItem[] = [
    {
      label: "Histoire",
      href: "/histoire",
      description: "Notre parcours depuis 1998"
    },
    {
      label: "Engagements",
      href: "/engagements",
      description: "Nos valeurs environnementales"
    },
    {
      label: "Nos Sites",
      href: "/sites",
      description: "Découvrez nos sites en France"
    },
    {
      label: "Valocap",
      href: "/valocap",
      description: "Notre plateforme de valorisation"
    },
    {
      label: "ValoGuide",
      href: "/valoguide",
      description: "Guide de valorisation des déchets"
    }
  ];

  const carriereItems: NavigationItem[] = [
    {
      label: "Nos Métiers",
      href: "/nos-metiers",
      description: "Découvrez nos différents métiers"
    },
    {
      label: "Recrutement",
      href: "/recrutement",
      description: "Rejoignez notre équipe"
    }
  ];

  return {
    services,
    serviceOfferings,
    valorisations,
    groupItems,
    sitesItems,
    valocapItems,
    // Legacy items
    servicesItems,
    groupeItems,
    carriereItems
  };
};
